import Vue from "vue";
import Antd from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import Axios from "axios";

import "ant-design-vue/dist/antd.css";

Vue.use(Antd);
Vue.use(Axios);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
